import { gql } from "@medbillai/generated-graphql-types";

/** Every Coverage screen reads this one operation, through `useCoverage`. */
export const coverageInsuranceQuery = gql(/* GraphQL */ `
  query CoverageInsurance {
    myInsurance {
      checkStatus {
        state
        missing
        problem
        lastRequestedAt
        lastAttemptAt
        lastAnsweredAt
      }
      noPrimaryReason
      memberships {
        id
        status
        primary
        accountHolder
        coverageType
        memberId
        subscriberMemberId
        relationship
        groupId
        person {
          firstName
          lastName
        }
        contacts {
          memberServicesPhone
          nurseLinePhone
          mentalHealthPhone
          pharmacyHelpPhone
        }
        pharmacy {
          rxBin
          rxPcn
          rxGroup
        }
        payerName
        payer {
          logoUrl
          primaryPayerId
        }
        plan {
          name
          type
          terminationDate
        }
        stale
        confirmedAt
        figuresFromSubscriber
        policyholder {
          firstName
          self
        }
        checkProblem
        checkIssue {
          fields {
            field
            reason
          }
        }
        planYear {
          start
          end
          status
        }
        positions {
          kind
          scope
          service
          headline
          metAmount
          limitAmount
          remainingAmount
          history {
            observedAt
            metAmount
            delta
            lead
          }
        }
        costShares {
          category
          network
          source
          covered
          copays {
            amount
            default
            deductibleApplies
          }
          coinsurances {
            amount
            default
            deductibleApplies
          }
        }
      }
    }
  }
`);
